module.exports = __webpack_public_path__ + "static/img/200335.7848bce5.png";